export enum RegShieldCallbackType {
  SCREEN_NAVIGATION = 'SCREEN_NAVIGATION',
  ACCOUNT_TYPE_MISMATCH = 'ACCOUNT_TYPE_MISMATCH',
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  INVALID_WIDGET_LINK = 'INVALID_WIDGET_LINK',
  USER_ID = 'USER_ID',
  CALLBACK = 'CALLBACK',
  REDIRECT_CHALLENGE = 'REDIRECT_CHALLENGE'
}

export type CallbackUserID = {
  type: RegShieldCallbackType.USER_ID;
  payload: {
    userID: string;
  };
};

export type CallbackScreenNavigation = {
  type: RegShieldCallbackType.SCREEN_NAVIGATION;
  payload: {
    currentScreen: string;
  };
};

export type CallbackInvalidWidgetLink = {
  type: RegShieldCallbackType.INVALID_WIDGET_LINK;
  payload: null;
};

export type CallbackAccountTypeMissMatch = {
  type: RegShieldCallbackType.ACCOUNT_TYPE_MISMATCH;
  payload: null;
};

export type CallbackAccountNotFound = {
  type: RegShieldCallbackType.ACCOUNT_NOT_FOUND;
  payload: null;
};

export type CallbackRedirectChallenge = {
  type: RegShieldCallbackType.REDIRECT_CHALLENGE;
  payload: {
    redirectUrl: string;
  };
};

export type CallbackQuery = {
  success: string;
  error_code: string;
  trace_id: string;
  state: string;
  code: string;
};

export type CallbackApi = {
  type: RegShieldCallbackType.CALLBACK;
  payload: {
    success: boolean;
    location: string;
    query: {
      query: CallbackQuery;
    };
  };
};

export type CallbackData =
  | CallbackInvalidWidgetLink
  | CallbackUserID
  | CallbackScreenNavigation
  | CallbackAccountTypeMissMatch
  | CallbackAccountNotFound
  | CallbackRedirectChallenge
  | CallbackApi;

export interface RegshieldCallbackFn {
  (error: Error | null, data: CallbackData): void;
}

declare global {
  interface Window {
    __finleapConnectWidget__: {
      init: (targetID: string, widgetLink: string, callback: RegshieldCallbackFn) => void;
      destroy: () => void;
    };
  }
}

export type CompleteRegShieldRegistrationPayload = {
  state: string;
  code: string;
  userId: string;
};

export type CompleteRegShieldRegistration = (payload: CompleteRegShieldRegistrationPayload) => void;

export type OnRegShieldError = (errorCode: number, traceId: string) => void;
export type OnRegShieldRedirectChallenge = (redirectUrl: string) => void;
